var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSolarPanelHovered = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 64,
    viewBox: "0 0 36 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9062 0.969238H0.90625V63.9692H35.9062V0.969238Z",
    fill: "#0072CE",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.40625 2.8988L35.0565 63.4692H1.40625V2.8988Z",
    fill: "#0072CE",
    stroke: "#0072CE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSolarPanelHovered);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SolarPanelHovered.9d7f733767b323722f6a97daaaa5ac91.svg";